import React from 'react';
import {useTranslation} from 'react-i18next';

import {
  LoadingButton,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  showModal,
} from '@edna/components';

import {ModalCenterImage} from 'src/components/primitives';
import {OverlapImage} from 'src/images';

import CompanyDetailsModal from './CompanyDetailsModal';
import PaymentDetailsModal from './PaymentDetailsModal';

type TProps = {
  closeModal: TEmptyFunction;
  isNeedFillCompanyDetails: boolean;
  isNeedFillPaymentDetails: boolean;
};

const ReminderModal = React.memo<TProps>(
  ({closeModal, isNeedFillCompanyDetails, isNeedFillPaymentDetails}) => {
    const {t} = useTranslation();

    const handleClick = React.useCallback(() => {
      closeModal();

      if (isNeedFillCompanyDetails) {
        showModal((closeCompanyDetailsModal) => (
          <CompanyDetailsModal
            closeModal={closeCompanyDetailsModal}
            isNeedFillPaymentDetails={isNeedFillPaymentDetails}
          />
        ));
      } else {
        showModal((closePaymentDetailsModal) => (
          <PaymentDetailsModal closeModal={closePaymentDetailsModal} />
        ));
      }
    }, [closeModal, isNeedFillCompanyDetails, isNeedFillPaymentDetails]);

    return (
      <Modal width="430px">
        <ModalHeader>{t('CompanyDetails:reminderModal.title')}</ModalHeader>
        <ModalContent>{t('CompanyDetails:reminderModal.text')}</ModalContent>
        <ModalCenterImage as={OverlapImage} />
        <ModalActions>
          <LoadingButton
            appearance="primary"
            onClick={handleClick}
            data-selector="CompanyDetails:reminderModal.button"
          >
            {t('CompanyDetails:reminderModal.button')}
          </LoadingButton>
        </ModalActions>
      </Modal>
    );
  },
);

export const showReminderModal = (
  isNeedFillCompanyDetails: TProps['isNeedFillCompanyDetails'],
  isNeedFillPaymentDetails: TProps['isNeedFillPaymentDetails'],
) =>
  showModal((closeModal) => (
    <ReminderModal
      closeModal={closeModal}
      isNeedFillCompanyDetails={isNeedFillCompanyDetails}
      isNeedFillPaymentDetails={isNeedFillPaymentDetails}
    />
  ));
